module.exports = __webpack_public_path__ + "fonts/GeneralSans-Semibold.fb699907.ttf";